export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18')
];

export const server_loads = [];

export const dictionary = {
		"/": [2],
		"/404": [3],
		"/beranda": [4],
		"/berita": [5],
		"/berita/[slug]": [6],
		"/direktorat": [7],
		"/dokumen": [8],
		"/galeri-video": [9],
		"/kontak-kami": [10],
		"/peraturan-perundangan": [11],
		"/peta-bppi": [13],
		"/peta": [12],
		"/prasyarat": [14],
		"/program-djppi": [15],
		"/struktur-organisasi": [16],
		"/survey-kepuasan": [17],
		"/tentang-kami": [18]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
};

export { default as root } from '../root.svelte';